// Data
import { arcParticipant }           from "../data/ARC.participant";
import { arcPremiumFinance }        from "../data/ARC.premium-finance";
import { arcPaymentInformation }    from "../data/ARC.payment-information";
import { arcReceipt }               from "../data/ARC.receipt";
import { arcRegisterButtons }       from '../data/ARC.register-buttons';

// Templates
import { arcContents }              from "./ARC.contents";
import { arcRatingGroups }          from "./ARC.rating-groups";

export function ataApplicationForm(store: any): any {
    const { programEnrollmentContents, ratingGroups } = store;

    const ataRules = {
        // Root
        applicationName: {
            "contactInformation.label": { equal: "<h2>General Information</h2>" },      // Change 'participant' section title.
            "businessName.visible": { equal: true }                                     // Display company name.
        },
        showLandingPage: {
            section: {
                any: [
                    { compare: ["#participantToken", "!!"], equal: "payment" },         // If participant token exists, set section to 'payment'.
                    { compare: ["#showLandingPage", "==", true], equal: "landing" },    // If show landing page exists, set section to 'landing'.
                    { compare: ["#showLandingPage", "==", false], equal: "register" }   // If show landing page doesn't exist, set section to 'register'.
                ]
            },
            "email.disabled": { compare: ["#showLandingPage", "==", true] },            // If show landing page exists, disable email input on register page.
            "backToLanding.visible": { compare: ["#showLandingPage", "==", true] },     // If show landing page exists, display back button on register page.
            "submitRegister.className": { compare: ["#showLandingPage", "==", true], equal: "text-right col-md-6", fallback: "text-right" }
        },
        section: {
            "verifyEmailForm.visible": { compare: ["#section", "==", "landing"] },      // If section is 'landing', display landing page.
            "registerForm.visible": { compare: ["#section", "==", "register"] },        // If section is 'register', display register page.
            "paymentForm.visible": { compare: ["#section", "==", "payment"] },          // If section is 'payment', display payment page.
            "receipt.visible": { compare: ["#section", "==", "receipt"] }               // If section is 'receipt', display receipt page.
        },
        // Landing
        showAdditionalInformation: {
            "businessName.visible": { compare: ["#showAdditionalInformation", "!=", true] },
            "policyNumber.visible": { compare: ["#showAdditionalInformation", "==", true] },            // If show additional info is true, display policy number input.
            "policyNumber.required": { compare: ["#showAdditionalInformation", "==", true] },
            "policyExpirationDate.visible": { compare: ["#showAdditionalInformation", "==", true] },    // If show additional info is true, display policy expiration date input.
            "coverageInformation.visible": { compare: ["#showAdditionalInformation", "!=", true] },     // If show additional info is false, display coverage information.
            "signature.visible": { compare: ["#showAdditionalInformation", "!=", true] },
            "content33.visible": { compare: ["#showAdditionalInformation", "!=", true] },
            "content32.visible": { compare: ["#showAdditionalInformation", "!=", true] },
            "contactInformation.label": {
                all: [
                    { compare: ["#showAdditionalInformation", "==", true] },
                    { compare: ["#renewal", "!=", true] }
                ],
                equal: `<h2>We are unable to locate your information.</h2>
                    <ul>
                        <li>If you were trying to register as <strong>New Business</strong>, please try the application form again with a different email if possible, and make sure to select "New Business" instead of "Renewal".</li>
                        <li>If you were trying to register as a <strong>Renewal</strong>, we have been unable to locate your existing information. This may be due to an expired policy past the 10 day grace period.</li>
                    </ul>
                    <h4>Please help us by supplying the following details.</h4>`,
                fallback: "<h2>General Information</h2>"
            },
            "submitRegister.value": { compare: ["#showAdditionalInformation", "==", true], equal: "submitAdditionalInfo", fallback: "submitRegisterForm" }
        },
        policyNumber: {
            "policyNumber.valid": { compare: ["#policyNumber.value", "!!"] }
        },
        policyExpirationDate: {
            "policyExpirationDate.valid": { compare: ["#policyExpirationDate.value", "regex", "^[0,1]?\\d{1}\\/\\d{1,2}\\/\\d{4}$"] },
            "policyExpirationDate.required": { compare: ["#policyExpirationDate.value", "!!"] }
        },
        verifyEmail: {
            "email.value": { equal: "#verifyEmail.value" },                                  // Set register email value equal to landing email value.
            "verifyEmail.valid": { compare: ["#verifyEmail.value", "regex", "^[\\w\\-\\.]+@([\\w-]+\\.)+[\\w-]{2,}$"] }
        },
        phone: {
            "phone.valid": { all: [
                { compare: ["#phone.value.1", ">", 1] }, // (100) 000-0000
                { compare: ["#phone.value.6", ">", 1] } // (000) 100-0000
            ]}
        },
        showRenewalMessage: {
            "verifyEmailForm.visible": { all: [
                { compare: ["#showRenewalMessage", "!"] },
                { compare: ["#section", "==", "landing"] }
            ]},
            "renewalMessage.visible": { compare: ["#showRenewalMessage", "!!"] }
        },
        showNewRenewalMessage: {
            "verifyEmailForm.visible": {
                all: [
                    { compare: ["#showNewRenewalMessage", "!"] },
                    { compare: ["#section", "==", "landing"] }
                ]
            },
            "newRenewalMessage.visible": { compare: ["#showNewRenewalMessage", "!!"] }
        },
        // Payment
        applicationFormResponse: {
            "saveQuote.visible": {
                all: [
                    { compare: ["#applicationFormResponse.programEnrollment.enableQuotes", "==", true] },
                    { compare: ["#applicationFormResponse.programEnrollment.autoReferral", "==", false] },
                    { compare: ["#participantToken", "!"]}
                ]
            }
        },
        isReferral: {
            //"premiumInformation.visible": { compare: ["#isReferral", "!=", true] },     // If is referral, hide premium information.
            "referralInformation.visible": { compare: ["#isReferral", "==", true] },    // If is referral, display referral information.
            "paymentInformation.visible": { compare: ["#isReferral", "!=", true] }      // If is referral, hide payment information.
        },
        allowCreditCard: {
            "creditcard.visible": { compare: ["#allowCreditCard", "!!"] }               // If allow credit card, display credit card payment selection.
        },
        allowAch: {
            "ach.visible": { compare: ["#allowAch", "!!"] }                             // If allow ach, display ach payment selection.
        },
        allowPremiumFinance: {
            "premiumFinance.visible": { compare: ["#allowPremiumFinance", "!!"] }       // If allow premium finance, display premium finance payment selection.
        },
        paymentType: {                                                                                              // [When Payment Type Changes:]
            "quoteDescription.visible": { compare: ["#paymentType.value", "==", "saveQuote"] },                         // If payment type is save quote, display quote message input.
            "creditCardPayment.visible": { compare: ["#paymentType.value", "==", "creditcard"] },                   // If payment type is credit card, display credit card inputs.
            "achPayment.visible": { compare: ["#paymentType.value", "==", "ach"] },                                 // If payment type is ach, display ach inputs.
            "premiumFinanceContainer.visible": { compare: ["#paymentType.value", "==", "premiumFinance"] },         // If payment type is premium finance, display premium finance inputs.
            "premiumFinanceSection": { compare: ["#paymentType.value", "==", "premiumFinance"], equal: "request" }  // If payment type is premium finance, set premium finance section to 'request'.
        },
        premiumFinanceType: {                                                                                       // [When Premium Finance Type Changes:]
            "socialSecurityNumber.visible": { compare: ["#premiumFinanceType.value", "==", "socialSecurity"] },     // If premium finance type is social security, display social security input.
            "feinNumber.visible": { compare: ["#premiumFinanceType.value", "==", "fein"] },                         // If premium finance type is fein, display fein input.
            "dateOfBirth.visible": { compare: ["#premiumFinanceType.value", "!!"] }                                 // If premium finance type is selected at all, display date of birth input.
        },
        premiumFinanceSection: {                                                                            // [When Premium Finance Section Changes:]
            "premiumFinanceRequest.visible": { compare: ["#premiumFinanceSection", "==", "request"] },      // If premium finance section is 'request', display premium finance request inputs.
            "premiumFinanceQuote.visible": {
                any: [
                    { compare: ["#premiumFinanceSection", "==", "terms"] },                                 // If premium finance section is 'terms', display premium finance quote.
                    { compare: ["#premiumFinanceSection", "==", "payment"] }                                // If premium finance section is 'payment', display premium finance quote.
                ]
            },
            "premiumFinanceTerms.visible": { compare: ["#premiumFinanceSection", "==", "terms"] },          // If premium finance section is 'terms', display premium finance terms.
            "premiumFinancePaymentType.visible": { compare: ["#premiumFinanceSection", "==", "payment"] },  // If premium finance section is 'payment', display premium finance payment type.
            "paymentInformation.visible": {
                any: [
                    { compare: ["#premiumFinanceSection", "!"] },                                           // If premium finance section is undefined, display payment information.
                    { compare: ["#premiumFinanceSection", "==", "payment"] }                                // If premium finance section is 'payment', display payment information.
                ]
            },
            "paymentTypeContainer.visible": { compare: ["#premiumFinanceSection", "!=", "payment"] }        // If premium finance section is 'payment', display payment type input.
        },
        premiumFinancePaymentType: {                                                                                // [When Premium Finance Payment Type Changes:]
            "creditCardPayment.visible": { compare: ["#premiumFinancePaymentType.value", "==", "pfCreditCard"] },   // If pf payment type is credit card, display credit card inputs.
            "achPayment.visible": { compare: ["#premiumFinancePaymentType.value", "==", "pfAch"] }                  // If pf payment type is ach, display ach inputs.
        },
        quoteDescription: {
            "paymentButtons.visible": { any: [{ compare: ["#achPayment.visible", "!!"] }, { compare: ["#creditCardPayment.visible", "!!"] }, { compare: ["#quoteDescription.visible", "!!"] }] },
            "submitPayment.label": { compare: ["#quoteDescription.visible", "!!"], equal: "Save Quote", fallback: "Pay" }
        },
        creditCardPayment: {                                                                                                                        // [When Credit Card Payment Visibility Changes:]
            "paymentFirstName.visible": { any: [{ compare: ["#achPayment.visible", "!!"] }, { compare: ["#creditCardPayment.visible", "!!"] }] },   // If cc or ach payments are visible, display first name.
            "paymentLastName.visible": { any: [{ compare: ["#achPayment.visible", "!!"] }, { compare: ["#creditCardPayment.visible", "!!"] }] },    // If cc or ach payments are visible, display last name.
            "paymentButtons.visible": { any: [{ compare: ["#achPayment.visible", "!!"] }, { compare: ["#creditCardPayment.visible", "!!"] }, { compare: ["#quoteDescription.visible", "!!"] }] }      // If cc or ach payments are visible, display payment buttons.
        },
        achPayment: {                                                                                                                               // [When ACH Payment Visibility Changes:]
            "paymentFirstName.visible": { any: [{ compare: ["#achPayment.visible", "!!"] }, { compare: ["#creditCardPayment.visible", "!!"] }] },   // If cc or ach payments are visible, display first name.
            "paymentLastName.visible": { any: [{ compare: ["#achPayment.visible", "!!"] }, { compare: ["#creditCardPayment.visible", "!!"] }] },    // If cc or ach payments are visible, display last name.
            "paymentButtons.visible": { any: [{ compare: ["#achPayment.visible", "!!"] }, { compare: ["#creditCardPayment.visible", "!!"] }, { compare: ["#quoteDescription.visible", "!!"] }] }      // If cc or ach payments are visible, display payment buttons.
        },
        saveQuoteResponse: {
            "paymentForm.visible": { all: [{ compare: ["#saveQuoteResponse", "!"] }, { compare: ["#section", "==", "payment"] }] },
            "quoteReceipt.visible": { compare: ["#saveQuoteResponse", "!!"] }
        },
        // Income
        65: {
            // limit $250,000
            "94.visible": { all: [{ compare: ["#65.value", "<", 250001] }, { compare: ["#65.value", ">", 0] }] },   // If 0 < income <= 250,000, display 250K limit.
            // limit $500,000
            "95.visible": { all: [{ compare: ["#65.value", "<", 250001] }, { compare: ["#65.value", ">", 0] }] },   // If 0 < income <= 250,000, display 500K limit.
            "96.visible": { compare: ["#65.value", ">", 0] },
            "97.visible": { compare: ["#65.value", ">", 0] },
            "98.visible": { compare: ["#65.value", ">", 0] },
            "99.visible": { compare: ["#65.value", ">", 0] },
            "187.visible": { compare: ["#65.value", ">", 0] },
            "188.visible": { compare: ["#65.value", ">", 0] },
            // deductible $250
            "125.visible": {    // If income <= 50,000 and limit is 250K or 500K, display $250 deductible.
                all: [
                    { compare: ["#65.value", "<", 50001] },
                    { any: [
                        { compare: ["#192.value", "==", "$250,000"] },
                        { compare: ["#192.value", "==", "$500,000"] }
                    ]}
                ]
            },
            // deductible $500
            "126.visible": {    // If income <= 250,000 and not(< 50,000 and limit is 250K or 500K), display $500 deductible.
                all: [
                    { compare: ["#65.value", "<", 250001] },
                    { not: {
                        all: [
                            { compare: ["#65.value", "<", 50001] },
                            { any: [
                                { compare: ["#192.value", "==", "$250,000"] },
                                { compare: ["#192.value", "==", "$500,000"] }
                            ]}
                        ]
                    }}
                ]
            },
            // deductible $1K*
            "127.visible": { compare: ["#65.value", ">", 250000] },
            // deductible $2.5K*
            "128.visible": { compare: ["#65.value", ">", 250000] },
            // deductible $5K*
            "129.visible": { compare: ["#65.value", ">", 250000] },
            // deductible $10K*
            "130.visible": { compare: ["#65.value", ">", 250000] }
        },
        // Limit
        192: {
            // deductible $250*
            "125.visible": {
                all: [
                    { compare: ["#65.value", "<", 50001] },
                    { any: [
                        { compare: ["#192.value", "==", "$250,000"] },
                        { compare: ["#192.value", "==", "$500,000"] }
                    ]}
                ]
            },
            // deductible $500
            "126.visible": {
                all: [
                    { compare: ["#65.value", "<", 250001] },
                    { not: {
                        all: [
                            { compare: ["#65.value", "<", 50001] },
                            { any: [
                                { compare: ["#192.value", "==", "$250,000"] },
                                { compare: ["#192.value", "==", "$500,000"] }
                            ]}
                        ]
                    }}
                ]
            }
        },
        // Insured Under ATA -> Retroactive Date
        115: {
            "115.valid": { all: [
                { compare: ["#115.value", "regex", "^[0,1]?\\d{1}\\/\\d{1,2}\\/\\d{4}$"] }, // Valid date
                { compareDate: ["#115.value", "<", "today"] }                               // not future
            ]}
        },
        // Insured Under ATA -> Expiration Date
        117: {
            "117.valid": { compare: ["#117.value", "regex", "^[0,1]?\\d{1}\\/\\d{1,2}\\/\\d{4}$"] }
        },
        // Insured under other (hide children when ata is selected)
        118: {
            "121.visible": { compare: ["#112.value", "==", "114"] },
            "122.visible": { compare: ["#112.value", "==", "114"] },
            "123.visible": { compare: ["#112.value", "==", "114"] },
            "124.visible": { compare: ["#112.value", "==", "114"] }
        },
        // Insured Under Other -> Expiration Date
        122: {
            "122.valid": { compare: ["#122.value", "regex", "^[0,1]?\\d{1}\\/\\d{1,2}\\/\\d{4}$"] }
        },
        // Insured Under Other -> Retroactive Date
        123: {
            "123.valid": { all: [
                { compare: ["#123.value", "regex", "^[0,1]?\\d{1}\\/\\d{1,2}\\/\\d{4}$"] }, // Valid date
                { compareDate: ["#123.value", "<", "today"] }                               // not future
            ]}
        },
        // Subcontract to others > If yes, percentage of total income
        84: {
            "84.valid": { compare: ["#84.value", "<", "101"] }
        },
        85: {
            "85.valid": { compare: ["#85.value", "<", "101"] }
        }
    };

    const ataLandingPage = {
        type: "form",
        itemId: "verifyEmailForm",
        className: "container",
        label: "<h3>Renewal Questions</h3>",
        items: [
            {
                type: "none",
                className: "pad-6-12",
                label: "Please select one of the following to help us identify if you are a new or returning customer. " +
                    "Enter your email address to help us determine if you are a new or returning plan participant."
            },
            {
                type: "radioGroup",
                itemId: "clientType",
                label: "Is this a renewal?",
                required: true,
                value: "isNewBusiness",
                items: [
                    {
                        type: "radio",
                        itemId: "isRenewal",
                        parentItemId: "clientType",
                        label: "Yes"
                    },
                    {
                        type: "radio",
                        itemId: "isNewBusiness",
                        parentItemId: "clientType",
                        label: "No"
                    }
                ]
            },
            {
                type: "email",
                itemId: "verifyEmail",
                label: "Please enter your email.",
                required: true
            },
            {
                type: "submit",
                itemId: "submitVerifyEmail",
                label: "Continue",
                className: "text-right",
                value: "submitVerifyEmailForm"
            }
        ]
    };

    const ataRenewalMessage = {
        type: "none",
        itemId: "renewalMessage",
        className: "container",
        label: `<h2>Please check your email!</h2>
            <p>To get started with renewing your policy, please check your email for a link to your renewal application.</p>
            <p>If you do not receive an email, please contact us at <a href="mailto:ata-questions@alliant.com">ata-questions@alliant.com</a>.</p>`,
        visible: false
    };

    const ataNewRenewalMessage = {
        type: "none",
        itemId: "newRenewalMessage",
        className: "container",
        label: `<h2>Existing Policy Found</h2>
            <p>We have detected an existing policy in place and we have sent you an email to renew your coverage.</p>
            <p>Please check your email, select the link, and complete the application and chosen payment transaction to renew your policy.</p>`,
        visible: false
    };

    const ataRegisterForm = {
        type: "form",
        itemId: "registerForm",
        items: [].concat(
            arcParticipant,
            {
                type: "none",
                itemId: "coverageInformation",
                label: "<h2>Coverage Information</h2>",
                items: arcRatingGroups(ratingGroups)
            },
            {
                type: "none",
                itemId: "signature",
                label: "<h3>Signature</h3>",
                items: [
                    {
                        type: "checkboxGroup",
                        itemId: "eSignContainer",
                        label: "E-Sign",
                        required: true,
                        items: [
                            {
                                type: "checkbox",
                                itemId: "eSign",
                                label: "I certify that the information I have given on the application is complete and correct."
                            }
                        ]
                    },
                    {
                        type: "text",
                        itemId: "applicantName",
                        label: "Applicant Name",
                        required: true
                    }
                ]
            },
            arcContents(programEnrollmentContents, "Footer"),
            arcRegisterButtons
        )
    };

    const ataPaymentForm = {
        type: "form",
        itemId: "paymentForm",
        items: [
            {
                type: "none",
                itemId: "policyInformation",
                items: [].concat(
                    arcContents(programEnrollmentContents, "PaymentHeader"),     // id = 4 -> Policy Information
                    arcContents(programEnrollmentContents, "PaymentBody")        // id = 5 -> Endorsements / Exclusions
                )
            },
            {
                type: "none",
                itemId: "referralInformation",
                className: "container",
                label: "<strong>Your application for coverage has been referred to Alliant Insurance Services for review. " +
                    "Please contact your Alliant Account team for any questions or assistance.</strong>" +
                    "<a href='/ata'>New Application</a>" +
                    "<div class='tooltip'>All current information will be lost unless saved as a quote.</div>"
            },
            arcPremiumFinance,
            arcPaymentInformation,
        ]
    };

    const quoteReceipt = {
        type: "none",
        itemId: "quoteReceipt",
        className: "container",
        label: "<strong><h2>Your quote has been saved.</h2><div>Please check your email for additional information.</div></strong>" +
            "<a href='/ata'>New Application</a>" +
            "<div class='tooltip'>All current information will be lost unless saved as a quote.</div>",
        visible: false
    };

    return {
        type: "none",
        itemId: "applicationFormItem",
        className: "main ata",
        rules: ataRules,
        items: [].concat(
            arcContents(programEnrollmentContents, "GlobalHeader", "global-header"),
            arcContents(programEnrollmentContents, "Header", "_register"),
            ataLandingPage,
            ataRenewalMessage,
            ataNewRenewalMessage,
            ataRegisterForm,
            ataPaymentForm,
            quoteReceipt,
            arcReceipt,
            arcContents(programEnrollmentContents, "GlobalFooter", "global-footer")
        )
    };
}
